import useSWR, { SWRResponse } from 'swr';
import hash from 'object-hash';
import initGraphQLClient, { GraphQLRequest, Variables } from '../../graphql/initGraphQLClient';

export default function useQuery<T = any>(request: GraphQLRequest<Variables>): SWRResponse<T, Error> {
  return useSWR(['useQuery', hash(request)],
    () => initGraphQLClient().query(request)
      // unwrap from useSwr 'data' and use only graphql 'data'
      .then((response: { data: T }) => response.data));
}
